import { Component, ElementRef, Input, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';

import {ApiService} from '../../shared/api.service';
import {NotificationService} from '../../shared/notification.service';
import {Slide} from '../slide/slide.model';
import {SlideshowService} from '../slideshow.service';
import {UserSettingsService} from '../../shared/user-settings.service';

@Component({
    selector: 'slides-component',
    templateUrl: 'slides.component.html'
})
export class SlidesComponent {
    searchText = '';
    placeholder = '';
    constructor(
        private notifyService: NotificationService, 
        private api: ApiService, 
        private userSettings: UserSettingsService, 
        private elem: ElementRef, 
        private slideshow: SlideshowService, 
        public dialog: MatDialog, 
        private router: Router) {}
        
    getContent(slide) {
        let items = slide.content;
        let content = [];
        if( this.slideshow.quiz ) {
            items = slide.feedback;
        }
        for(var i = 0; i < items.length; i++) {
            content.push(items[i].text);
        }
        return content.join('. ');
    }
    getSrc(images) {
        if( !images[0].hasOwnProperty('url') ) {
            return '';
        }
        const img = images[0];
        let src = img.url;
        if( img.hasOwnProperty('sizes') && img.sizes.hasOwnProperty('thumbnail') ) {
            src = img.sizes.thumbnail.url;
        }
        return src;
    }
    openDialog(oldIndex, newIndex, slide) {
        let dialog = this.dialog.open(TeaserDialog);
        dialog.afterClosed().subscribe(cancel => {
            if( cancel ) {
                this.slideshow.slides.splice(newIndex, 1);
                this.slideshow.slides.splice(oldIndex, 0, slide);
                this.slideshow.setSlideOrder();
            }
        });
    }
    navigate(e, i) {
        e.stopPropagation();
        if( !e.target.closest('.actions') && !e.target.closest('.comments') && !this.userSettings.settings.slidePreviewToggle ) {
            this.slideshow.setSlide(i);
        }        
    }
    openComments(i) {
        this.slideshow.slides[i].commentsOpen = true;
        setTimeout(() => {
            let input = this.elem.nativeElement.querySelector('.slide-' + i).querySelector('.comments-input');
            if( input ) {
                input.focus();
            }
        }, 150);
        
    }
    saveComments(comments, id) {
        for(var i = 0; i < comments.length; i++) {
            let comment = comments[i];
            comment.post = id;
            if( !comment.id ) {
                this.api.doAction('post', 'comment', comment).subscribe(
                    data => {
                        this.notifyService.comment(comment, this.slideshow.assignment);
                    }
                );
            }
        }
    }
    updateComments(e, i) {
        let slide = this.slideshow.slides[i];
        this.slideshow.slides[i].comments = e;
        if( !slide.id ) {
            this.api.doAction('post', 'save', slide).subscribe(
                data => {
                    data.title = data.title.raw;
                    for(var prop in data) {
                        this.slideshow.slides[i][prop] = data[prop];
                    }
                    this.saveComments(e, slide.id);
                    this.slideshow.saveAssignment();
                }
            );
        }
    }
    findAncestor (el, className) {
        while ((el = el.parentElement) && el.className.indexOf(className) === -1);
        return el;
    }
    dragStart(e) {
        let slideEl = e.target;
        if( slideEl.className.indexOf('slide') === -1 ) {
            slideEl = this.findAncestor(e.target, 'slide');
        }
        this.placeholder = slideEl.innerHTML;
    }
    drop(e) {
        this.placeholder = '';
        let oldIndex = e.data;
        let newIndex = e.index > oldIndex && e.index !== 0 ? e.index -1 : e.index;
        if( oldIndex != newIndex ) {
            let slides = this.slideshow.slides;
            let slide = slides[oldIndex];
            let lastIndex = slides.length - 1;
            if( newIndex === 0 && slides[0].intro ) {
                newIndex = 1;
            }
            if( newIndex === lastIndex && slides[lastIndex].outro ) {
                newIndex = lastIndex - 1;
            }
            slides.splice(oldIndex, 1);
            slides.splice(newIndex, 0, slide);
            this.slideshow.setSlideOrder();
            if( slide.teaser ) {
                this.openDialog(oldIndex, newIndex, slide);
            }
        }
    }
    getPropValues(props) {
        return (obj) => {
            return props.map(prop => obj[prop]).join('');
        }
    }
    getSearchString(item) {
        let searchString = '';
        searchString += JSON.stringify(item.headers);
        searchString += this.getPropValues([
            'metaDescription', 
            'metaTitle', 
            'title', 
            'teaser'
        ])(item);

        // add content
        let content = item.content;
        for(var i = 0; i < content.length; i++) {
            let result = content[i];
            searchString += this.getPropValues(['text', 'title'])(result);
            if( result.hasOwnProperty('image') ) {
                let image = result.image;
                searchString += this.getPropValues([
                    'alt', 
                    'caption', 
                    'credit', 
                    'description',
                    'filename',
                    'mime',
                    'name',
                    'title',
                    'url'
                ])(image);
            }
        }

        // add images
        searchString += item.images.map(this.getPropValues([
            'alt', 
            'caption', 
            'credit', 
            'description',
            'filename',
            'mime',
            'name',
            'title',
            'url'
        ])).join('');

        // add search
        searchString += item.search.map(this.getPropValues([
            'name'
        ])).join('');

        // add comments
        let comments = item.hasOwnProperty('comments') ? item.comments : [];
        searchString += comments.map(this.getPropValues([
            'abbreviation', 
            'author_name', 
            'text'
        ])).join('');

        // add quiz feedback
        searchString += item.feedback.map(this.getPropValues([
            'text'
        ])).join('');

        return searchString;
    }
    searchFilter(item, searchText) {
        let value = searchText.toLowerCase();
        if( !value || value === '' ) {
            return false;
        }
        let searchString = this.getSearchString(item);
        return searchString.toLowerCase().indexOf(value) === -1;
    }
}

@Component({
    selector: 'teaser-dialog',
    template: `
        <h2 mat-dialog-title>Teaser</h2>
        <mat-dialog-content>This slide contains teaser text. Are you sure you want to move it?</mat-dialog-content>
        <mat-dialog-actions>
            <button mat-button [mat-dialog-close]="true">Cancel</button>
            <button mat-button mat-dialog-close>Yes</button>
        </mat-dialog-actions>`,
})
export class TeaserDialog {}


// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/src/swarm/src/app/slideshow/slides/slides.component.ts